/* KE fix 2026-11-03: keep Checkout visible in the side cart */
(function(){
  function cookieOffset(){
    var b=document.querySelector('.cky-consent-container:not(.cky-hide), .cky-consent-bar');
    var h=0; if(b){var r=b.getBoundingClientRect(); if(r.height>0 && getComputedStyle(b).display!=='none') h=Math.round(window.innerHeight-r.top);}
    document.documentElement.style.setProperty('--ke-cky-h', Math.max(0,h)+'px');
    var bar=document.querySelector('.sticky-atc-wrapper'), chat=document.getElementById('chat-button');
    if(chat && bar && window.innerWidth<750 && /template-product/.test(document.body.className)){
      var open=/page-overlay-cart-on/.test(document.body.className);
      var want=open?'':(Math.max(0,h)+bar.getBoundingClientRect().height+12)+'px';
      if(want && chat.style.getPropertyValue('bottom')!==want) chat.style.setProperty('bottom',want,'important');
    }
  }
  function build(){
    var inner=document.querySelector('#CartDrawer .wt-cart__drawer__inner');
    var real=document.getElementById('CartDrawer-Checkout');
    if(!inner||!real) return;
    var bar=inner.querySelector('.ke-pin-co');
    if(!bar){
      bar=document.createElement('div'); bar.className='ke-pin-co';
      bar.innerHTML='<div class="ke-pin-co__total"><small>Subtotal</small><strong></strong></div><button type="button" class="ke-pin-co__btn">Check out</button>';
      bar.querySelector('button').addEventListener('click',function(){var r=document.getElementById('CartDrawer-Checkout'); if(r) r.click();});
      inner.appendChild(bar);
    }
    var v=document.querySelector('#CartDrawer .wt-cart__subtotal__value');
    var txt=v?v.textContent.trim():''; var st=bar.querySelector('strong'); if(st.textContent!==txt) st.textContent=txt;
    var empty=!document.querySelector('#CartDrawer .wt-cart__item');
    if(bar.hidden!==empty) bar.hidden=empty;
    if(window.IntersectionObserver && !real.__keIO){
      real.__keIO=new IntersectionObserver(function(es){es.forEach(function(e){var b=document.querySelector('.ke-pin-co'); if(b && !b.hidden) b.style.visibility=e.isIntersecting?'hidden':'visible';});},{root:inner,threshold:0.6});
      real.__keIO.observe(real);
    }
  }
  var t; function soon(){clearTimeout(t); t=setTimeout(function(){build();cookieOffset();},120);}
  new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){var n=ms[i].target; if(!(n.closest&&n.closest('.ke-pin-co'))){soon();return;}}}).observe(document.documentElement,{childList:true,subtree:true});
  window.addEventListener('resize',soon); document.addEventListener('click',function(){setTimeout(cookieOffset,400);},true);
  var n=0, iv=setInterval(function(){cookieOffset(); if(++n>30) clearInterval(iv);},700); document.addEventListener('DOMContentLoaded',soon); soon();
})();
/* KE fix 2026-11-03 (2): keep the free-shipping bar and the bag count in step with the real cart.
   Some add paths (free-gift app, Save My Edges gift) redraw only the item list, which left the bar
   showing an old "$X away" amount and the bag count missing. After every cart change, read /cart.js
   and update both. */
(function(){
  if (window.__keCartSync) return; window.__keCartSync = true;
  var FREE = 6000, nf = window.fetch.bind(window), t = null;
  function money(c){ return '$' + (c/100).toFixed(2); }
  function paint(cart){
    var n = cart.item_count || 0, left = Math.max(0, FREE - (cart.total_price || 0));
    document.querySelectorAll('#cart-icon-bubble').forEach(function(b){
      var c = b.querySelector('.wt-header__panel__counter');
      if (n > 0) {
        if (!c) { c = document.createElement('span'); c.className = 'wt-header__panel__counter'; var lab = b.querySelector('.wt-header__panel__label'); b.insertBefore(c, lab || null); }
        if (c.textContent !== String(n)) c.textContent = String(n);
      } else if (c) { c.remove(); }
    });
    var body = document.getElementById('CartDrawer-Body'); if (!body) return;
    var bar = body.querySelector('.wt-free-shipping-bar');
    if (!n) { if (bar) bar.style.display = 'none'; return; }
    if (!bar) {
      bar = document.createElement('div'); bar.className = 'wt-free-shipping-bar';
      bar.innerHTML = '<p class="wt-free-shipping-bar__text"></p><div class="wt-progress-bar"><div class="wt-progress-bar__fill"></div></div>';
      body.insertBefore(bar, body.firstChild);
    }
    bar.style.display = '';
    var txt = bar.querySelector('.wt-free-shipping-bar__text'), fill = bar.querySelector('.wt-progress-bar__fill');
    var html = left > 0 ? 'You’re ' + money(left) + ' away from free shipping + a free Brow &amp; Lash&nbsp;gift'
                        : 'You’ve unlocked free shipping + a free Brow &amp; Lash&nbsp;gift!';
    if (txt && txt.innerHTML !== html) txt.innerHTML = html;
    bar.classList.toggle('wt-free-shipping-bar--success', left <= 0);
    if (fill) fill.style.width = Math.round((FREE - left) * 100 / FREE) + '%';
    var head = document.querySelector('#CartDrawer .ke-upsell__heading');
    if (head) { var h2 = left > 0 ? 'Add ' + money(left) + ' for free shipping + a free&nbsp;gift' : 'Add to your order'; if (head.innerHTML !== h2) head.innerHTML = h2; }
  }
  function sync(){ clearTimeout(t); t = setTimeout(function(){
    nf('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function(r){ return r.json(); }).then(paint).catch(function(){});
  }, 350); }
  function isCart(u){ try { return /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(new URL(typeof u === 'string' ? u : (u && u.url) || String(u), location.origin).pathname); } catch(e){ return false; } }
  var of = window.fetch;
  window.fetch = function(input){ var p = of.apply(this, arguments); try { if (isCart(input)) p.then(function(){ sync(); setTimeout(sync, 2500); }, function(){}); } catch(e){} return p; };
  var XO = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, u){ try { if (isCart(u)) this.addEventListener('loadend', function(){ sync(); setTimeout(sync, 2500); }); } catch(e){} return XO.apply(this, arguments); };
  var d = document.getElementById('CartDrawer');
  if (d) new MutationObserver(function(ms){ for (var i=0;i<ms.length;i++){ var n=ms[i].target; if (n.closest && (n.closest('.wt-free-shipping-bar') || n.closest('.ke-pin-co'))) continue; sync(); return; } }).observe(d, { childList: true, subtree: true });
  document.addEventListener('cart:refresh', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
/* KE fix 2026-11-03 (3): the side cart's X only closed when the tap landed on the round button's edge.
   A tap on the X itself hits the drawn line inside the icon, which the theme ignored. Any tap on the
   button now closes the cart. */
document.addEventListener('click', function(e){
  var x = e.target && e.target.closest && e.target.closest('.wt-cart__drawer__close--button');
  if (!x) return;
  e.preventDefault(); e.stopPropagation();
  var cd = document.querySelector('cart-drawer');
  if (cd && typeof cd.toggleDrawerClasses === 'function' && document.body.classList.contains('page-overlay-cart-on')) cd.toggleDrawerClasses();
}, true);
/* KE fix 2026-11-03 (4): smoother homepage motion.
   a) "Watch their routines" reels: the infinite loop used to jump the track by a full set of slides
      in the MIDDLE of a swipe (around the 4th swipe), which flashed on phones. It now waits until the
      swipe has fully stopped, so the jump lands on an identical frame and can't be seen.
   b) Homepage hero: slides used to snap over quickly, and the last slide rewound across every slide
      to get back to the first. Slides now glide over with an eased 0.9s motion, and the loop back to
      the first slide is a soft fade instead of a rewind. */
(function(){
  if (window.__keMotion) return; window.__keMotion = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function fixReels(el){
    if (!el.track || el.__keFixed || typeof el.wrapLoop !== 'function') return;
    el.__keFixed = true;
    if (el._onScroll) el.track.removeEventListener('scroll', el._onScroll);
    var timer = null, settle = function(){ clearTimeout(timer); timer = setTimeout(function(){ el.wrapLoop(); }, 180); };
    el._onScroll = settle;
    el.track.addEventListener('scroll', settle, { passive: true });
  }
  function ease(t){ return t < .5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3) / 2; }
  function glide(track, to, ms){
    var from = track.scrollLeft, start = null;
    track.style.scrollSnapType = 'none';
    return new Promise(function(done){
      function f(ts){ if (start === null) start = ts; var p = Math.min(1, (ts - start) / ms);
        track.scrollLeft = from + (to - from) * ease(p);
        if (p < 1) requestAnimationFrame(f); else { track.style.scrollSnapType = ''; done(); } }
      requestAnimationFrame(f);
    });
  }
  function fixHero(el){
    if (!el.track || el.__keFixed) return;
    el.__keFixed = true;
    el.goToPage = function(index){
      var track = this.track; if (!track) return;
      var to = index * track.clientWidth;
      if (reduce) { track.scrollLeft = to; return; }
      var wrapping = index === 0 && this.currentPage() === this.pageCount() - 1 && this.pageCount() > 2;
      if (wrapping) {
        track.style.transition = 'opacity .35s ease'; track.style.opacity = '0';
        setTimeout(function(){ track.style.scrollSnapType = 'none'; track.scrollLeft = 0;
          requestAnimationFrame(function(){ track.style.scrollSnapType = ''; track.style.opacity = '1'; }); }, 360);
      } else {
        glide(track, to, 900);
      }
    };
  }
  function run(){
    if (window.customElements) {
      customElements.whenDefined('c-reels-carousel').then(function(){ document.querySelectorAll('c-reels-carousel').forEach(fixReels); });
      customElements.whenDefined('c-carousel').then(function(){ document.querySelectorAll('[id^="c-hero-"] c-carousel').forEach(fixHero); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
/* KE fix 2026-11-03 (5): phone menu > Shop. Shop by collection now leads as a row of product tiles
   you can swipe (castor oil, Rosemary Mint, Save Our Scalp, Moringa & Mango, Moringa skincare, bundles),
   above Shop by concern. The old collapsed "Shop by Collection" list is hidden on phones so the same
   links don't show twice. Desktop menu is unchanged. */
(function(){
  if (window.__keShopNav) return; window.__keShopNav = true;
  var C = [
    ['Haitian Black Castor Oil','/collections/haitian-black-castor-oil','https://cdn.shopify.com/s/files/1/1087/6916/files/hf_20260515_145649_7a50819e-14ea-43f4-a034-64646a5943fd.png?v=1778860373'],
    ['Rosemary Mint','/collections/rosemary-mint-collection','https://cdn.shopify.com/s/files/1/1087/6916/files/ShampooModified.jpg?v=1778872101'],
    ['Santé: Save Our Scalp','/collections/save-our-scalp','https://cdn.shopify.com/s/files/1/1087/6916/files/sos_serum_30ml_hair_serum.png?v=1791114099'],
    ['Moringa & Mango Stylers','/collections/moringa-mango-treatment-stylers','https://cdn.shopify.com/s/files/1/1087/6916/files/hf_20260516_212511_3b7059b2-cf8f-4d3a-aa42-0d67ab7daeb1.png?v=1778966884'],
    ['Moringa Skincare','/collections/skin-care','https://cdn.shopify.com/s/files/1/1087/6916/files/hf_20260515_144124_18a056bb-8e64-4df4-b5c4-bfcc43725331.png?v=1778860367'],
    ['Bundles','/collections/clinically-infused-scalp-hair-bundles','https://cdn.shopify.com/s/files/1/1087/6916/files/growth-trio-2oz-styled-v3.jpg?v=1792766388']
  ];
  function esc(s){ return s.replace(/&/g,'&amp;'); }
  function build(){
    document.querySelectorAll('ul.ke-shop').forEach(function(ul){
      if (ul.querySelector('.ke-col')) return;
      var head = ul.querySelector('.ke-shop__head'); if (!head) return;
      var li = document.createElement('li');
      li.className = 'wt-page-nav-mega__sublist__item ke-col';
      li.innerHTML = '<div class="ke-col__head"><span class="ke-shop__eyebrow">Shop by collection</span><a href="/collections/all" class="ke-col__all" data-menu-level="2">Shop all &rarr;</a></div>' +
        '<div class="ke-col__row">' + C.map(function(c){
          return '<a class="ke-col__tile" href="' + c[1] + '" data-menu-level="2"><span class="ke-col__img"><img src="' + c[2] + '&width=300" alt="" loading="lazy" width="150" height="150"></span><span class="ke-col__label">' + esc(c[0]) + '</span></a>';
        }).join('') + '</div>';
      ul.insertBefore(li, head);
      ul.querySelectorAll('.ke-shop__group').forEach(function(g){
        var t = g.querySelector('.ke-shop__group-title');
        if (t && /collection/i.test(t.textContent)) g.classList.add('ke-col-dup');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
  setTimeout(build, 1500);
})();
